<template>
<div></div>
</template>

<script>
export default {
  name: "UserChallenges"
};
</script>

<style scoped>

</style>
